<template>
  <div>
    <div class="member-main-tab">
      <ul class="main-tab">
        <li class="active">我的班级</li>
      </ul>
    </div>
    <div class="member-main-body">
      <div class="no-data" v-show="dataList.length <= 0">
        <img src="../../assets/images/v3/no-data.png" />
        <p>暂无班级信息</p>
      </div>
      <div class="class-list" v-for="(item, index) in dataList" :key="index">
        <div class="class-item-img">
          <img
            v-if="item.gradecover"
            :src="concatImageUrl(item.gradecover, 280, 160)"
          />
          <span v-else>{{ item.gradename }}</span>
        </div>
        <div class="class-item-info">
          <p class="class-name">{{ item.gradename }}</p>
          <p>开班时间：{{ item.starttime }}</p>
          <p>课程：{{ item.courseCount }}门</p>
          <p>专业：{{ item.majorName }}</p>
          <p>教学点：{{ item.orgName }}</p>
        </div>
        <div class="class-item-btn">
          <Button
            type="primary"
            shape="circle"
            style="height: 28px; line-height: 28px;"
            long
            :to="{ name: 'ClassDetail', params: { id: item.gradecode } }"
            >进入班级</Button
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { siteMixin } from "../../utils/mixin";
import { user } from "../../request";
export default {
  mixins: [siteMixin],
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      user
        .getClassList(this.siteConfig.agencyId, this.loginUser.userId)
        .then((res) => {
          //console.log("classList", res);
          if (res.status === 1) {
            this.dataList = res.data;
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../assets/css/var.less";
@import "../../assets/css/member-main.less";

.class-list {
  display: flex;
  margin: 0 30px;
  padding: 30px 0;
  align-items: flex-start;
  border-bottom: 1px solid #eee;
  .class-item-no {
    margin: 20px auto;
    text-align: center;
    p {
      margin-top: 10px;
      font-size: 1.6rem;
      text-indent: 1em;
    }
  }
  .class-item-img {
    display: flex;
    width: 280px;
    height: 160px;
    background-color: #41a5fd;
    color: #fff;
    border-radius: 6px;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    overflow: hidden;
    img {
      width: 280px;
      height: 160px;
    }
  }
  .class-item-info {
    flex: 1 1;
    padding-left: 20px;
    height: 160px;
    overflow: hidden;
    p {
      height: 30px;
      font-size: 15px;
      color: #666;
    }
    .class-name {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin-bottom: 10px;
    } 
  }
  .class-item-btn {
    width: 100px;
    height: 50px;
  }
}
</style>